export interface Hotspot {
  name: string;
  left: number;
  top: number;
  width: number;
  height: number;
  transform?: string;
}

export enum HotspotNames {
  ProductResources = 'product-resources',
  RequestMeeting = 'request-meeting',
  ExpertChallenge = 'expert-challenge',
  ExpertChallengeBillboard = 'expert-challenge-billboard',
  VideoResources = 'video-resources',
  MedicalInformation = 'medical-information',

  PDFLeft = 'pdf-left',
  PDFMiddle = 'pdf-middle',
  PDFRight = 'pdf-right'
}

export const hotspots: Hotspot[] = [
  {
    name: HotspotNames.ProductResources,
    top: 447.94,
    left: 134.52,
    width: 1355.72,
    height: 158.57,
    transform: 'skewY(3.5deg)'
  },
  {
    name: HotspotNames.RequestMeeting,
    top: 852.28,
    left: 21.54,
    width: 707.60,
    height: 198.21,
    transform: 'skewY(1.5deg)'
  },
  {
    name: HotspotNames.ExpertChallenge,
    top: 796.78,
    left: 913.47,
    width: 507.40,
    height: 154.60,
    transform: 'skewY(1.5deg)'
  },
  {
    name: HotspotNames.ExpertChallengeBillboard,
    top: 989.04,
    left: 1024.46,
    width: 305.24,
    height: 440.02
  },
  {
    name: HotspotNames.VideoResources,
    top: 592.63,
    left: 3648.7,
    width: 1341.85,
    height: 132.80,
    transform: 'skewY(-3.5deg)'
  },
  {
    name: HotspotNames.MedicalInformation,
    top: 1082.2,
    left: 3983.66,
    width: 1036.62,
    height: 109.01
  },

  {
    name: HotspotNames.PDFLeft,
    top: 842.37,
    left: 1632.95,
    width: 511.37,
    height: 814.62
  },
  {
    name: HotspotNames.PDFMiddle,
    top: 852.28,
    left: 2405.95,
    width: 503.44,
    height: 796.79
  },
  {
    name: HotspotNames.PDFRight,
    top: 848.32,
    left: 3149.22,
    width: 529.21,
    height: 816.60
  }
];
